/**
 * Scroll-reveal is now pure CSS (see `styles.css`, scroll-driven `view()` timeline),
 * so no JavaScript ever mutates server-rendered markup — that used to break hydration
 * on lazily-hydrated routes. Kept as a no-op so the root layout stays unchanged.
 */
export function ScrollReveal() {
  return null;
}
